import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

/**
 * Entities the standalone /catalog-graph page opens on.
 *
 * `useCatalogGraphPage` falls back to `initialState.rootEntityRefs ?? []` when the
 * URL carries no `rootEntityRefs` query parameter, and with an empty root list
 * `EntityRelationsGraph` renders no graph at all. Since the sidebar links to the
 * bare path, the page would always open blank without a seed. The two product
 * domains are the roots of the whole catalog, so they expand into everything.
 */
export const catalogGraphRootEntityRefs = [
  'domain:default/ubp',
  'domain:default/uio',
];

/**
 * Seeds the catalog graph page with root entities.
 *
 * This cannot be done from `app.extensions` in app-config.yaml: the extension
 * spreads its config onto `<CatalogGraphPage {...config} />`, but the component
 * reads these values from its `initialState` prop only, so configured
 * `rootEntityRefs` are silently dropped. Overriding the loader keeps the
 * extension id, its path and its route ref, so the "View graph" deep links from
 * entity cards - which pass `rootEntityRefs` in the query string and therefore
 * take precedence over the seed - keep working.
 */
export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [
    catalogGraphPlugin.getExtension('page:catalog-graph').override({
      params: {
        path: '/catalog-graph',
        loader: () =>
          import('@backstage/plugin-catalog-graph').then(m => (
            <m.CatalogGraphPage
              initialState={{ rootEntityRefs: catalogGraphRootEntityRefs }}
            />
          )),
      },
    }),
  ],
});
